@import "/src/variables/font_size";
@import "/src/variables/color";
@import "/src/variables/font";
@import "/src/variables/tokens";
@import "/src/variables/breakpoints";
.appVersion {
  color: $zv-text-secondary--Font-Color;
  font-family: $font-primary;
  font-size: $font-size-h9;
  position: fixed;
  bottom: 5px;
  left: 20px;
}

.main {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  background-color: $zv-canvas--Primary-BG-Color;
  position: relative;
  display: flex;
  flex-direction: column;

  .headBox {
    background-color: transparent;
    align-self: flex-end;
    justify-self: flex-end;
    margin-top: $space-10;
    margin-right: $space-8;
    margin-bottom: $space-15;
    gap: $space-5;
    &:hover{
      background-color: transparent;
    }

    .editLogo {
      height: 14px;
      width: auto;
      cursor: pointer;
    }

    .title {
      font-size: $font-size-h10;
      line-height: $line-height-ratio-1;
      // opacity: 0.8;
      font-weight: $font-weight-semibold;
      font-family: $font-primary;
      color: $zv-text-secondary--Font-Color;
      text-transform: capitalize;
    }
  }

  .box {
    background-color: $zv-canvas--Primary-BG-Color;
    width: 100%;
    position: relative;
  }

  height: 100%;

  @media only screen and (min-width: $breakpoint-tablet) {
    max-width: 170px;
    width: 14vw;
  }

  .getHelpCard {
    display: flex;
    flex-direction: column;
    gap: $space-5;
    margin: 0px 0px $space-8 $space-30;

    .getHelp {
      color: $zv-text-muted--gray-56;
      font-size: $font-size-h11;
      font-family: $font-primary;
      font-weight: $font-weight-semibold;
      text-align: left;
      cursor: pointer !important;
    }
  }
}

.main::before,
.main::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.divider {
  position: absolute;
  border-top: $border-width-0-5 solid $zv-border--gray-59;
  // margin: 0 18px;
  top: 110px;
  z-index: $z-index-2;
  left: 18px;
  right: 18px;
}

.arrowButton {
  position: absolute;
  top: 75px;
  z-index: $z-index-2;
  right: 18px;
  height: 15px;
}


.bookBtn {
  border: none;
  width: max-content;
  margin: 0;
  padding: 0;
  // margin-left: 43px;
  margin-left: $space-20;
  margin-bottom: $space-9;
  line-height: $line-height-ratio-1;
  font-weight: $font-weight-semibold;
  font-family: $font-primary;
  color: $zv-text-muted--gray-56;
  font-size: $font-size-h11;
  cursor: pointer;
}